import {
  Show,
  useRecordContext,
  usePermissions,
} from "react-admin";

import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Chip,
  Grid,
} from "@mui/material";

import { useState } from "react";

const AssessmentShowContent = () => {
  const { permissions = [] } = usePermissions();
  const record = useRecordContext();
  console.log("SHOW RECORD =", record);
  const [tab, setTab] = useState(0);
  if (
    !(
      permissions.includes("assessments.read") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }


  if (!record) return null;

  return (
    <Box p={3}>
      {/* HEADER */}
      <Typography variant="h5" mb={2}>
        {record.title}
      </Typography>

      {/* TABS */}
      <Tabs
        value={tab}
        onChange={(e, v) => setTab(v)}
        sx={{ mb: 2 }}
      >
        <Tab label="Assessment" />
        <Tab label="Questions" />
        <Tab label="Instructions" />
      </Tabs>

      {/* ================= TAB 1 ================= */}
      {tab === 0 && (
        <Paper sx={{ p: 3, borderRadius: "16px" }}>
          <Typography mb={2}>
            {record.description}
          </Typography>
          {/* ASSESSMENT IMAGE */}
            {record.image && (
              <Box mb={3}>
                <img
                  src={`http://localhost:8000/api${record.image}`}
                  alt="Assessment"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    borderRadius: "16px",
                    border: "1px solid #ccc",
                  }}
                />
              </Box>
            )}


          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Chip
                label={`Duration: ${record.duration} min`}
                fullWidth
              />
            </Grid>

            <Grid item xs={4}>
              <Chip
                label={`Passing: ${record.passing_score}`}
              />
            </Grid>

            <Grid item xs={4}>
              <Chip
                label={`Total: ${record.total_score}`}
              />
            </Grid>
          </Grid>
          
              {/* CERTIFICATE PDF */}
              {record.certificate_pdf_url && (
                <Paper
                  sx={{
                    p: 3,
                    mt: 3,
                    borderRadius: "16px",
                  }}
                >
                  <Typography variant="h6" mb={2}>
                    Assigned Certificate
                  </Typography>

                  <a
                    href={`http://localhost:8000/api/${record.certificate_pdf_url}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Certificate PDF
                  </a>
                </Paper>
              )}

              </Paper>
              )}
      

      {/* ================= TAB 2 ================= */}
      {tab === 1 && (
        <Box>
          {record.questions?.length ? (
            record.questions.map((q, index) => (
              <Paper
                key={q.id}
                sx={{
                  p: 2,
                  mb: 2,
                  borderRadius: "16px",
                }}
              >
                {/* QUESTION NUMBER */}
                <Typography variant="subtitle2" mb={1}>
                  Q{index + 1}
                </Typography>

                {/* HTML CONTENT */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: q.title,
                  }}
                />

                {/* TAGS */}
                <Box mt={2} display="flex" gap={1}>
                  <Chip label={q.difficulty_level} />

                  <Chip
                    label={`Marks: ${
                      q.question_data?.marks || 0
                    }`}
                  />
                </Box>
              </Paper>
            ))
          ) : (
            <Typography>No questions added</Typography>
          )}
        </Box>
      )}

      {/* ================= TAB 3 ================= */}
      {tab === 2 && (
        <Paper sx={{ p: 3, borderRadius: "16px" }}>
          <Typography variant="h6" mb={2}>
            Instructions
          </Typography>

          {record.instructions ? (
            <div
              dangerouslySetInnerHTML={{
                __html: record.instructions,
              }}
            />
          ) : (
            <Typography color="text.secondary">
              No instructions added.
            </Typography>
          )}
        </Paper>
      )}
    </Box>
  );
};

const AssessmentShow = () => (
  <Show>
    <AssessmentShowContent />
  </Show>
);

export default AssessmentShow;